module.exports = __webpack_public_path__ + "static/media/pictoreal_logo.dba9c038.png";